import { RequestStatus } from '@upright/ui/api/common/types';
import Icon from '@upright/ui/common/generic/components/icons/hero-icons/hi-exclamation-triangle.svg';
import { GenericOverlayBox } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/generic-overlay-box';
import { useCarouselContext } from '@upright/ui/common/upright/core/impact-lens-profile/context';
import styled from 'styled-components';

export function LensErrorState() {
  const context = useCarouselContext();
  const error = context.data.loadingStatus === RequestStatus.ERROR;
  if (!error) {
    return <></>;
  }
  return (
    <GenericOverlayBox
      title={
        <>
          <Icon style={{ height: '1.2em', width: '1.2em', marginRight: '0.8em' }} />
          Data failed to load
        </>
      }
    >
      <Main>
        <p>
          The data for this impact lens failed to load. This may be caused by problems with internet connection, or
          momentary technical problems within Upright's technical infrastructure, caused e.g. by heavy traffic.
        </p>
        <p>
          Please check your internet connection and try reloading the page. If the problem persist, please try again
          later, or contact Upright for assistance.
        </p>
      </Main>
    </GenericOverlayBox>
  );
}

const Main = styled.div`
  p {
    margin-top: 0em;
    margin-bottom: 1.4em;
  }
`;
